export const needsToBeDisplayed = (status, employmentSituation) => status.includes(employmentSituation);
